export const authtoken = localStorage.getItem('authtoken');
export const permissions = localStorage.getItem('permissions'); 
var user_info = JSON.parse(localStorage.getItem('user-info'));

export const rolename = (user_info)?user_info.rolename:''; 
export const roletype = (user_info)?user_info.roletype:''; 
export const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
